import {Typography} from '@mui/material';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as ExchangeIcon} from '../../../../src/assests/svg/icon_shift.svg';
import {t} from 'i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openDialog} from '../../../redux/slices/reportsDialogSlice';
import ProjectWorkSpaceSelectionDialog from '../HostingUserSummaryReport/WorkSpaceSummary/ProjectWorkSpaceSelectionDialog';
import ProjectWorkSpaceSelection from '../HostingUserSummaryReport/WorkSpaceSummary/ProjectWorkSpaceSelection';
import {RootState} from '../../../redux/store';
import {getUTCDateTimeForDisplay} from '../../../utils/utils';
import AurHighlyConfidential from '../../common/aur-highly-confidential/AurHighlyConfidential';
import {AurLightTooltip} from '../../common/aur-light-tooltip/aur-light-tooltip';

const HighLevelProductionReportHeader = () => {
  const dispatch = useDispatch();

  const {
    refreshDates,
    selectedProjectName: projectName,
    selectedWorkSpaceName: workSpaceName,
    currentProject: project,
  } = useSelector((state: RootState) => state.reports);

  const handleOpenDialog = () => {
    dispatch(openDialog());
  };

  return (
    <div className="high-level-production-report-header">
      {project?.highlyConfidential && (
        <AurHighlyConfidential
          type="pill"
          showWarningText={true}
          className="highly-confidential-alert"
        />
      )}
      <div className="high-level-production-report-summary-heading ">
        <Typography className="typo-text subhead3_size">
          {projectName}
        </Typography>
      </div>
      <div className="high-level-production-report-sub-title">
        <Typography className="typo-text display3_size title-section ">
          {workSpaceName}
        </Typography>
        <AurButton
          ariaLabel={`${t('reports.hostingUserSummary.project')} | ${t('reports.hostingUserSummary.workspace')}`}
          classNames="typo-text buttonMedium_size"
          onClick={handleOpenDialog}
          type="continue"
          size="Medium"
          startIcon={<ExchangeIcon aria-hidden="true" />}
        >
          {t('reports.hostingUserSummary.project')}{' '}
          <span className="color-button-divider"> | </span>
          {t('reports.hostingUserSummary.workspace')}
        </AurButton>
        <ProjectWorkSpaceSelectionDialog
          ContentComponent={ProjectWorkSpaceSelection}
          openFrom={t('reports.projectOverview.tabs.tabProductionMetrics')}
        />
      </div>
      <div className="high-level-production-report-date-section">
        <Typography className="typo-text body3_size">
          {t('reports.hostingUserSummary.data')}{' '}
          <AurLightTooltip title={t('common.yearMonthDate')}>
            <span className="typo-text label1_size high-level-production-report-date-sub-section">
              {getUTCDateTimeForDisplay(
                refreshDates.highlevelProductionMetrics || ''
              )}
            </span>
          </AurLightTooltip>
        </Typography>
        <Typography className="typo-text body3_size">
          {t('reports.hostingUserSummary.description')}
        </Typography>
      </div>
    </div>
  );
};

export default HighLevelProductionReportHeader;
